import {
  CHANGE_CURRENT_ORDER,
  SAVE_ORDER_START,
  SAVE_ORDER_SUCCESS,
  SAVE_ORDER_FAILURE,
  FETCH_CURRENT_ORDER_START,
  FETCH_CURRENT_ORDER_SUCCESS,
  FETCH_CURRENT_ORDER_FAILURE,
  TOGGLE_MODAL_ORDER,
  FETCH_GOODS_SUCCESS
} from '../actionTypes';
import * as api from '../api';
import orderDataPreparation from '../utilities/orderDataPreparation';

// timeDelay время бездействия пользователя после которого будет сохранен заказ
// getOrder bool - запрос текущего заказа после запроса сохранения
// showModalOrder - показать модальное окно с заказом
let timerId;

export const changeCurrentOrder = (
  field,
  timeDelay = 500,
  getOrder = false,
  showModalOrder = true
) => async (dispatch, getState) => {
  dispatch({
    type: CHANGE_CURRENT_ORDER,
    payload: field
  });
  clearTimeout(timerId);
  timerId = setTimeout(() => {
    const { order } = getState().currentOrder;
    dispatch({ type: SAVE_ORDER_START });
    const orderData = orderDataPreparation(order);
    api
      .saveOrder(orderData)
      .then(data => {
        dispatch({
          type: SAVE_ORDER_SUCCESS,
          payload: data
        });
        if (getOrder) {
          dispatch({ type: FETCH_CURRENT_ORDER_START });
          api
            .getCurrentOrder()
            .then(dataOrder => {
              // получить (обновить) данные по заказу у же с добавленным товаром
              dispatch({
                type: FETCH_CURRENT_ORDER_SUCCESS,
                payload: dataOrder
              });
              // добавить данные data в объект товара в заказе
              dispatch({
                type: FETCH_GOODS_SUCCESS,
                payload: getState().goods
              });
              // открыть модальное окно с заказом
              if (showModalOrder) {
                dispatch({
                  type: TOGGLE_MODAL_ORDER,
                  payload: true
                });
              }
            })
            .catch(err => {
              dispatch({
                type: FETCH_CURRENT_ORDER_FAILURE,
                payload: err,
                error: true
              });
            });
        }
      })
      .catch(err => {
        dispatch({
          type: SAVE_ORDER_FAILURE,
          payload: err,
          error: true
        });
      });
  }, timeDelay);
};
